export default __webpack_public_path__ + "static/media/p1.5d95842d.jpg";